export default "__VITE_ASSET__Bcs$Ecs4__"